import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImageAltText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImageAltText"><Path d="M6.5 17.5H11.5M14.5 17.5H17.5M20.5 14.5V3.5H3.5V12V14.5M20.5 14.5V20.5H3.5V14.5M20.5 14.5H15.5H3.5M3.75 11.675L8 7L15.25 14.25M17.5 8C17.5 8.82843 16.8284 9.5 16 9.5C15.1716 9.5 14.5 8.82843 14.5 8C14.5 7.17157 15.1716 6.5 16 6.5C16.8284 6.5 17.5 7.17157 17.5 8Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconImageAltText;
